import { THEME } from "./theme"

export interface HeroColorTheme {
  glow: number
  glowText: string
  neon: number
  glowShadow: string
}

export function getHeroColorTheme(heroId: string): HeroColorTheme {
  if (heroId === "krmelo") {
    return {
      glow: THEME.heroColors.krmelo.glow,
      glowText: THEME.heroColors.krmelo.glowText,
      neon: THEME.heroColors.krmelo.neon,
      glowShadow: THEME.shadows.yellow,
    }
  }
  return {
    glow: THEME.heroColors.bella.glow,
    glowText: THEME.heroColors.bella.glowText,
    neon: THEME.heroColors.bella.neon,
    glowShadow: THEME.shadows.pink,
  }
}
